import React from "react";

const FilterSummary = ({
    filteredCount,
    totalCount,
}: {
    filteredCount: number;
    totalCount: number;
}) => (
    <div className="text-sm text-gray-500 mb-2">
        Showing {filteredCount} of {totalCount} accounts
    </div>
);

export default FilterSummary;
